import api from '@/api'

export default {
  async fetchAll({commit}) {
    const positions = api.positions.all()
    commit('setPositions', positions)
    return positions
  },
}
